export * from '@radix-ui/react-accessible-icon';
